import React from 'react'
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { useTranslation } from 'react-i18next'

export default function CompleteModal({ onOpenModal, setOnCloseModal }) {
  const { t } = useTranslation()

  return (
    <CommonModal hideModal={setOnCloseModal} isOpen={onOpenModal} ariaHideApp={false}>
      <CommonModal.Header hideModal={setOnCloseModal}>{t('features.GuideTour.Modal.Title')}</CommonModal.Header>
      <CommonModal.Body>{t('features.GuideTour.Modal.CompleteTutorial')} </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons>
          <Button onClick={setOnCloseModal}>{t('features.GuideTour.Button.close')}</Button>
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </CommonModal>
  )
}
